import './Blog.css';
import Posts from '../../../posts';
import { Link } from 'react-router-dom';

const Blog = () => {
  return (
    <div className="blogmaincss">
      <div className="wrapper">
        <h1 className="primary-heading ">Latest on Your Friend Blog</h1>
        <main>
          {Posts.slice(0, 4).map((post) => (
            <div className="singleBlog" key={post.id}>
              <img src={post.image} alt={post.title}></img>
              <div className="blogContent">
                <h3>
                  {post.title}
                  <span>Article</span>
                </h3>
                <Link to={`/blog/${post.id}`} className="btn">
                  Read More
                </Link>
              </div>
            </div>
          ))}
        </main>
        {/* <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: '30px',
          }}
        >
          <Link to="/blog" className="btn">
            Read more
          </Link>
        </div> */}
      </div>
    </div>
  );
};

export default Blog;
